module.exports = __webpack_public_path__ + "OnePlus_6_icon.svg?d75191e1c8043425b368fc587186b0f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/OnePlus_6_icon.svg
// module id = 205
// module chunks = 0